export default __webpack_public_path__ + "static/media/trashIcon.2eb49196.svg";